import { getDeviceKeys } from 'hooks/useGoBack';
import { useSingleKeyComboTrigger } from 'hooks/useKeyComboTrigger';
import { logger } from 'logger';
import { useCallback } from 'react';
import { emitCustomEvent } from 'react-custom-events';
import { Device, DeviceSubtype, getDevice, getDeviceSubtype } from 'utils/getDevice';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const LOG = logger.getLogger('useGoBack');

const device = getDevice();
const deviceSubtype = getDeviceSubtype();
const backKey = getDeviceKeys().BACK;

/**
 * Used to detect the final back pressed event to show our exit dialog so we can send an event to the vega wrapper
 * to close.  If vegaos gets less janky and gives us an api to check whether the webview can go back from the wrapper,
 * then we could probably remove this and follow the same pattern that we do for android.
 */
export function useVegaOsGoBackDetection(): void {
  const handleBackButton = useCallback(() => {
    LOG.info('vegaOS back button press detected');
    LOG.debug('window.navigation?.canGoBack: ', window.navigation?.canGoBack);
    if (device === Device.firetv && deviceSubtype === DeviceSubtype.vegaos && !window.navigation?.canGoBack) {
      emitCustomEvent('SHOW_EXIT_APP_DIALOG');
    }
  }, []);

  useSingleKeyComboTrigger([backKey], handleBackButton);
}
